import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // Import the default export
import { ThemeProvider } from "./context/ThemeContext";
import { Provider } from "react-redux"; // Import the Redux Provider
import { store } from "./redux/store"; // Import your Redux store
import "./styles/global.css"; // Ensure global styles are loaded

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}> {/* Wrap App with Redux Provider */}
      <ThemeProvider>  {/*wrap app with Context API*/}
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);